import useCreateDeposit from '@/lib/api/create-deposit';
import { defaultChain, getChainDecimals } from '@/lib/wagmi/config';
import { ExternalAction } from '@/types';
import { parseDecimalToBigInt } from '@/utils/value-format';
import { usePrivy } from '@privy-io/react-auth';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function EventHandler() {
  const { createDeposit } = useCreateDeposit();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const action = searchParams.get('action') as ExternalAction | null;

  const { ready, authenticated, login } = usePrivy();

  useEffect(() => {
    if (!action) return;
    switch (action) {
      case ExternalAction.LOG_IN:
        if (!ready) return;
        navigate({ search: '' });
        if (authenticated) return;
        login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, authenticated, action]);

  useEffect(() => {
    const navigateHandler = (e: Event) => {
      const detail = (e as CustomEvent<{ pathname?: string; search?: string }>)
        .detail;
      if (!detail) return;
      const { pathname, search } = detail;
      navigate({
        pathname,
        search,
      });
    };

    const depositHandler = (e: Event) => {
      const { amount } = (e as CustomEvent<{ amount: string }>).detail;
      createDeposit({
        size: parseDecimalToBigInt(amount, getChainDecimals(defaultChain.id)),
        chainId: defaultChain.id,
      });
    };

    window.addEventListener('app:deposit', depositHandler);
    window.addEventListener('app:navigate', navigateHandler);
    return () => {
      window.addEventListener('app:deposit', depositHandler);
      window.removeEventListener('app:navigate', navigateHandler);
    };
  }, []);

  return <></>;
}
